import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-355">
      <div className="max-w-5xl mx-auto" data-id="element-356">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-357">
          Lo que <span className="text-[#FFD700]" data-id="element-358">recibís</span>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-5xl mx-auto mb-12" data-id="element-359">
          {/* PRIMARIA */}
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-360">
            <h3 className="text-[#FFD700] text-xl font-black mb-4" data-id="element-361">
              ✝️ PRIMARIA — 6 TOMOS
            </h3>
            <div className="space-y-4" data-id="element-362">
              <div className="flex items-start gap-3 text-white" data-id="element-363">
                <span className="text-lg" data-id="element-364">🟦</span>
                <p className="text-sm" data-id="element-365">
                  <span className="font-bold" data-id="element-366">
                    Tomo 1 — DIOS NOS REGALA LA VIDA (1° Grado · 6-7 años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-367">
                    · Despertar espiritual: Dios creador, Jesús amigo, oración y
                    valores.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-368">
                <span className="text-lg" data-id="element-369">🟩</span>
                <p className="text-sm" data-id="element-370">
                  <span className="font-bold" data-id="element-371">
                    Tomo 2 — LA PALABRA DE DIOS NOS HABLA (2° Grado · 7-8 años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-372">
                    · Primeros contenidos bíblicos, signos cristianos y
                    preparación para la Reconciliación.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-373">
                <span className="text-lg" data-id="element-374">🟨</span>
                <p className="text-sm" data-id="element-375">
                  <span className="font-bold" data-id="element-376">
                    Tomo 3 — JESÚS CAMINA CON NOSOTROS (3° Grado · 8-9 años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-377">
                    · Vida de Jesús, los Mandamientos, Reconciliación y
                    preparación para la Primera Comunión.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-378">
                <span className="text-lg" data-id="element-379">🟧</span>
                <p className="text-sm" data-id="element-380">
                  <span className="font-bold" data-id="element-381">
                    Tomo 4 — VIVIR LA FE EN COMUNIDAD (4° Grado · 9-10 años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-382">
                    · Los 7 Sacramentos, Eucaristía, Año Litúrgico, María y
                    Santos argentinos.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-383">
                <span className="text-lg" data-id="element-384">🟪</span>
                <p className="text-sm" data-id="element-385">
                  <span className="font-bold" data-id="element-386">
                    Tomo 5 — LAS RAÍCES DE NUESTRA FE (5° Grado · 10-11 años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-387">
                    · Historia de la salvación, Antiguo Testamento, Profetas y
                    preparación para la Confirmación.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-388">
                <span className="text-lg" data-id="element-389">🟥</span>
                <p className="text-sm" data-id="element-390">
                  <span className="font-bold" data-id="element-391">
                    Tomo 6 — SALIR AL MUNDO CON EL EVANGELIO (6° Grado · 11-12
                    años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-392">
                    · Nuevo Testamento, Iglesia primitiva, Doctrina Social y
                    proyecto solidario.
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* SECUNDARIA */}
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-393">
            <h3 className="text-[#FFD700] text-xl font-black mb-4" data-id="element-394">
              ✝️ SECUNDARIA — 6 TOMOS
            </h3>
            <div className="space-y-4" data-id="element-395">
              <div className="flex items-start gap-3 text-white" data-id="element-396">
                <span className="text-lg" data-id="element-397">📗</span>
                <p className="text-sm" data-id="element-398">
                  <span className="font-bold" data-id="element-399">
                    Tomo 7 — DESCUBRIR A JESÚS DESDE ADENTRO (1° Año · 12-13
                    años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-400">
                    · De fe infantil a fe reflexiva: Biblia crítica, contexto de
                    Jesús y el Reino de Dios.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-401">
                <span className="text-lg" data-id="element-402">📘</span>
                <p className="text-sm" data-id="element-403">
                  <span className="font-bold" data-id="element-404">
                    Tomo 8 — ¿QUIÉN SOY? ¿PARA QUÉ ESTOY AQUÍ? (2° Año · 13-14
                    años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-405">
                    · Identidad, libertad, sacramentos en profundidad y relación
                    madura con la Iglesia.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-406">
                <span className="text-lg" data-id="element-407">📙</span>
                <p className="text-sm" data-id="element-408">
                  <span className="font-bold" data-id="element-409">
                    Tomo 9 — FE QUE TRANSFORMA EL MUNDO (3° Año · 14-15 años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-410">
                    · Doctrina Social, justicia, opción por los pobres y
                    ecología integral.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-411">
                <span className="text-lg" data-id="element-412">📕</span>
                <p className="text-sm" data-id="element-413">
                  <span className="font-bold" data-id="element-414">
                    Tomo 10 — ¿CÓMO QUIERO VIVIR? ¿QUIÉN QUIERO SER? (4° Año ·
                    15-16 años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-415">
                    · Ética, afectividad, vocación, discernimiento y proyecto de
                    vida.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-416">
                <span className="text-lg" data-id="element-417">📓</span>
                <p className="text-sm" data-id="element-418">
                  <span className="font-bold" data-id="element-419">
                    Tomo 11 — PENSAR LA FE, CREER CON LA RAZÓN (5° Año · 16-17
                    años)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-420">
                    · Filosofía, fe y ciencia, religiones comparadas y bioética
                    contemporánea.
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-421">
                <span className="text-lg" data-id="element-422">📒</span>
                <p className="text-sm" data-id="element-423">
                  <span className="font-bold" data-id="element-424">
                    Tomo 12 — FE, VIDA Y MISIÓN (6° Año · Cierre de Secundaria)
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-425">
                    · Vocación, liderazgo cristiano, compromiso social y
                    proyecto solidario final.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#FFD700]/5 border border-[#FFD700]/30 rounded-2xl p-8 text-center" data-id="element-426">
          <h3 className="text-[#FFD700] text-xl font-black mb-6" data-id="element-427">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 max-w-3xl mx-auto" data-id="element-428">
            <div className="flex items-start gap-2 text-left" data-id="element-429">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-430">✅</span>
              <span className="text-white text-sm" data-id="element-431">
                Planificación anual lista
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-432">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-433">✅</span>
              <span className="text-white text-sm" data-id="element-434">
                Unidades con objetivos claros
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-435">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-436">✅</span>
              <span className="text-white text-sm" data-id="element-437">
                Adaptado por edad y nivel de fe
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-438">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-439">✅</span>
              <span className="text-white text-sm" data-id="element-440">
                Recursos y dinámicas incluidas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-441">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-442">✅</span>
              <span className="text-white text-sm" data-id="element-443">
                Año Litúrgico argentino
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-444">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-445">✅</span>
              <span className="text-white text-sm" data-id="element-446">
                Criterio doctrinal + pedagógico
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-447">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-448">✅</span>
              <span className="text-white text-sm" data-id="element-449">
                Parroquia, colegio o mixto
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-450">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-451">✅</span>
              <span className="text-white text-sm" data-id="element-452">
                Tips para la realidad argentina
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}